import React, { useState } from 'react';
import {
  CreateLinkNoHoverDevices,
  ECardTitle,
  ECardWrapper,
  StorefrontGridWrapper,
  StyledStorefrontCell,
} from '@components/storefront/StorefrontGrid/StorefrontGrid.styles';
import { Column, Columns } from '@components/Columns';
import { StorefrontECard } from '@components/storefront/StorefrontECard/StorefrontECard';
import { getCardThemeId, getSignUpScenario, getUseTemplateCtaId } from '@utils/storefront.util';
import { getCardCreateWeddingUrl } from '@utils/urlHelpers.util';
import { eCardsStorefrontPageContentData } from '@data-ts/components/storefront/ECardsStorefrontPageContent';

interface Props
  extends Readonly<{
    cards: ReadonlyArray<StorefrontECard>;
  }> {}

interface StorefrontECardCellProps
  extends Readonly<{
    card: StorefrontECard;
  }> {}

const copyData = eCardsStorefrontPageContentData;

const StorefrontECardCell: React.FC<StorefrontECardCellProps> = ({ card }) => {
  const [isHovered, setHovered] = useState(false);
  // pages render only card that have themeId defined
  const themeId = getCardThemeId(card)!;
  const signUpScenario = getSignUpScenario(card.productType);
  return (
    <StyledStorefrontCell onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <ECardWrapper $isHovered={isHovered}>
        <StorefrontECard data={card} isHovered={isHovered} />
      </ECardWrapper>
      <ECardTitle tagName={'p'} variant={'featureCopy17'} color={'neutra6'} textAlign={'center'}>
        {card.title}
      </ECardTitle>
      <CreateLinkNoHoverDevices
        id={getUseTemplateCtaId(card.productType, themeId) + 'Link'}
        href={`${getCardCreateWeddingUrl(signUpScenario, themeId)}`}
        target="_self"
        typography={'featureCopy17'}
        telemetryLabel={themeId}
      >
        {copyData.useThisTemplate}
      </CreateLinkNoHoverDevices>
    </StyledStorefrontCell>
  );
};

export const StorefrontGrid: React.FC<Props> = ({ cards }) => {
  return (
    <StorefrontGridWrapper>
      <Columns multiline>
        {cards.map((card, index) => {
          return (
            <Column tablet={'six'} desktop={'four'} key={index}>
              <StorefrontECardCell card={card} />
            </Column>
          );
        })}
      </Columns>
    </StorefrontGridWrapper>
  );
};
